import { ToastProgrammatic as Toast } from 'buefy';
import Vue from 'vue';
import { EVENTS } from '../store/modules/websocket/websocket.state';
import { useWebsocket } from './websocket.util';

const displayToastError = () => {
  Toast.open({
    message: `Error processing. Please try again later.`,
    duration: 3000,
    type: 'is-danger'
  });
};

export const subscribeToRealTime = async function (
  this: Vue,
  jobId: string,
  callback: Function
) {
  if (!jobId) {
    displayToastError();
    return;
  }

  const { connectToWs, joinRoom, listenTo, disconnectWs } = useWebsocket.call(
    this
  );

  await connectToWs();
  joinRoom(jobId);
  const unsubscribeEvent = listenTo(EVENTS.EVENT_UPDATED, () => callback());
  const unsubscribeImage = listenTo(EVENTS.IMAGE_UPDATED, () => callback());
  const unsubscribeMember = listenTo(EVENTS.MEMBER_UPDATED, () => callback());

  // return cleanup so component can destroy it
  return () => {
    unsubscribeEvent();
    unsubscribeImage();
    unsubscribeMember();
    disconnectWs();
  };
};
